<template lang="pug">
div
  div(@click="handleOpenClick")
    slot(name="activator")
  v-dialog.d-inline(v-model="isModalVisible" lazy persistent max-width="480")
    v-card
      title-bar(dark :loading="isLoading") {{ title }}
      v-card-text
        v-autocomplete(
          solo
          flat
          clearable
          hide-selected
          prepend-inner-icon="search"
          :items="staticLists"
          placeholder="Search Static lists"
          item-text="name"
          :item-value="selectedListValue"
          v-model="selectedList"
          :loading="isStaticListLoading"
        )
          template(slot="item" slot-scope="{ item }")
            v-layout {{ item.name }}
              v-icon.facebook-logo(v-if="item.fb_user_type_id" color="primary" right) {{ getIcon(item.fb_user_type_id) }}
        p
          v-icon.mr-2 info
          | Your contact(s) will also be added to any custom audiences synced with the selected static list.
      v-card-actions
        v-spacer
        v-btn(flat @click="cancel") Cancel
        v-btn.primary(@click="save" :disabled='!selectedList || showWarning') ADD
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import Modal from '@/Core/mixins/modal';

const { 
  mapState: mapContactsTableState,
  mapActions: mapContactsTableActions,
} = createNamespacedHelpers('contactsTable');

const {
  mapActions: mapContactsTableBulkActionActions,
  mapState: mapContactsTableBulkState,
} = createNamespacedHelpers('contactsTable/bulkActions');

export default {
  components: {
    TitleBar,
  },
  mixins: [Modal],
  data() {
    return {
      selectedList: null,
      showWarning: false,
      showError: false,
    };
  },
  computed: {
    ...mapContactsTableState({
      contactsTableLoading: state => state.isLoading,
      staticLists: state => state.emailLists,
      isStaticListLoading: state => state.isStaticListLoading,
    }),
    ...mapContactsTableBulkState({
      isLoading: state => state.isStaticListLoading,
    }),
    title() {
      if (this.selectedIds.length === 1) {
        return 'Add contact to static list';
      }
      return `Add ${this.selectedIds.length} Contacts to static list`;
    },
  },
  props: {
    selectedIds: {
      type: Array,
    },
    fetchAllContacts: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    ...mapContactsTableBulkActionActions(['addContactsToStaticList']),
    ...mapContactsTableActions(['loadEmailLists']),
    selectedListValue(list) {
      return { id: list.id, name: list.name };
    },
    async save() {
      await this.addContactsToStaticList({
        listId: this.selectedList.id,
        contactsIds: this.selectedIds,
      });
      this.$emit('deselect-all');
      this.$emit('contact-updated');
      this.selectedList = null;
      this.modal_close();
    },
    cancel() {
      this.selectedList = null;
      this.modal_close();
    },
    getIcon(fbUserTypeId) {
      const icon = fbUserTypeId === 'Personal' ? '$vuetify.icons.facebook' : '$vuetify.icons.liondesk';
      return icon;
    },
    async handleOpenClick() {
      await this.fetchAllContacts();
      this.loadEmailLists();
      // it breaks if triggered along with the other calls
      setTimeout(this.modal_open, 100);
    },
  },
};
</script>
